import * as type from '../../../actions/index.types'

export function adminLoginReducer(state = {
    loading: false,
    reloginLoading: true,
    loginData: null,
    registerData: null,
    error: null
}, action) {

    switch (action.type) {
        case type.ADMIN_REGISTER:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.ADMIN_REGISTER_SUCCESS: {

            return {
                ...state,
                error: null,
                loading: false,
                registerData: action.payload,
            }
        }
        case type.ADMIN_REGISTER_FAILURE:
            return {
                ...state,
                error: action?.message || 'Somthing went wrong.',
                loading: false,
            }
        case type.ADMIN_LOGIN:
            console.log(action)
            return {
                ...state,
                loading: true,
                reloginLoading: action?.data?.autoLogin ? true : false,
                error: null,
            }
        case type.ADMIN_LOGIN_SUCCESS: {

            return {
                ...state,
                error: null,
                loading: false,
                reloginLoading: false,
                loginData: action.payload,
            }
        }
        case type.ADMIN_LOGIN_FAILURE:
            return {
                ...state,
                error: action?.message || 'Somthing went wrong.',
                loading: false,
                reloginLoading: false
            }


        case type.ADMIN_RELOGIN:
            return {
                ...state,
                reloginLoading: true,
                error: null,
            }

        case type.ADMIN_RELOGIN_SUCCESS: {

            return {
                ...state,
                loginData: action.payload,
                error: null,
                loading: false,
                reloginLoading: false,
            }
        }

        case type.ADMIN_RELOGIN_FAILURE:
            return {
                ...state,
                error: action?.message || 'Somthing went wrong.',
                loading: false,
                reloginLoading: false
            }


        // The profile page's sidebar and its Cancel button both read from
        // loginData.user, which is only ever written at login. Without merging the
        // saved profile back in, a successful update left the store holding the
        // pre-edit values — so Cancel reverted the form to them.
        case type.CTRL_UPDATE_PROFILE_SUCCESS: {
            const updatedUser = action?.payload?.data;
            if (!updatedUser || !state.loginData) return state;
            return {
                ...state,
                loginData: {
                    ...state.loginData,
                    user: { ...state.loginData.user, ...updatedUser },
                },
            }
        }

        case type.ADMIN_LOGOUT_SUCCESS:
            return {
                ...state,
                error: null,
                loginData: null,
            }



        default:
            return state
    }
}